import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from "react-router"
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'

import Rightbar from '../cheques/Rightbar'
import { httpOk, GET, FILE_D } from 'helpers/api'
import {
	findKeyFromArrayByValue, formatDate, formatMoney, returnSign
} from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip"
import { businessToday, businessMonthStart } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()
	const { client_id } = useParams()

	const reduxAccount = useSelector(state => state.account)

	const transactionTypes = [
		{ 'id': 'plus', 'name': t('debit') },
		{ 'id': 'minus', 'name': t('credit') },
	]

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		pos_id: reduxAccount.pos_id,
		transaction_type: null,
		start_date: businessMonthStart(),
		end_date: businessToday(),
		fast_date_id: null,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: `/report-clients-history/${client_id}`,
		response: null
	})

	async function toggleRightbar(boolean = false, item, index) {
		var dataCopy = { ...data }

		for (let i = 0; i < dataCopy.data.length; i++) {
			dataCopy.data[i]['showSidebar'] = false
		}

		if (item.cheque_id) {
			if (boolean) {
				const response = await GET(`/cheques/${item.cheque_id}`, {}, { loader: true })
				if (httpOk(response)) {

					dataCopy.data[index]['showSidebar'] = boolean
					setSelectedItem(response.data.data)
					setShowRightBar(boolean)
				}
			} else {
				setShowRightBar(boolean)
				setSelectedItem({})
			}
		}
	}

	async function searchWithFilter(passedData = {}) {
		var filterUrl = `/report-clients-history/${client_id}`
		var urlParams = ""
		const filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + filterDataCopy.transaction_type
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		if (`/report-clients-history/${client_id}${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setFilterData(filterDataCopy)
		setDropdownIsOpen(false)
	}

	async function downloadExcelFile() {
		var filterUrl = `/report-clients-history/${client_id}`
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.transaction_type)
			urlParams += returnSign(urlParams) + 'transaction_type=' + filterData.transaction_type
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		urlParams += returnSign(urlParams) + 'excel=true'

		const responseExcel = await FILE_D(filterUrl + urlParams, { loader: true })
		if (httpOk(responseExcel)) {
			const file = new Blob([responseExcel.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', `client-debts.xlsx`)
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	async function paginate(page) {
		const nextFilterData = { ...filterData, 'page': page }
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function resetFilter() {
		const nextFilterData = {
			pos_id: reduxAccount.pos_id,
			transaction_type: null,
			start_date: businessMonthStart(),
			end_date: businessToday(),
			fast_date_id: null,
			search: '',
		}
		setFilterData(nextFilterData)
		searchWithFilter({ filterData: nextFilterData })
	}

	function checkFilter(currentFilterData = filterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	useEffect(() => {
		getPoses()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex text-truncate">
				<h4 className="vertical-center h-100">
					{t('debtor')}
				</h4>
				<div className="vertical-center">
					<i className="uil uil-angle-double-right fz-20"></i>
				</div>
				<div className="vertical-center" title={data?.client?.client_id}>
					<h6>{data?.client?.first_name}</h6>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex gap-2">
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}
								onSearchChange={(search) => {
									const nextFilterData = { ...filterData, search, page: null }
									setFilterData(nextFilterData)
									searchWithFilter({ filterData: nextFilterData })
								}}>
							</FilterSearch>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="d-flex gap-2">
											<div className="form-group w-100">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group w-100">
												<label>{t('transaction_type')}</label>
												<Select
													isClearable
													options={transactionTypes}
													value={transactionTypes.find(option => option.id === filterData.transaction_type) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'transaction_type': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="form-group">
											<label>{t('period')}</label>
											<PeriodPicker
												startDate={filterData.start_date}
												endDate={filterData.end_date}
												onChange={(period, presetId) => setFilterData({ ...filterData, ...period, 'fast_date_id': presetId })}
												withTime={false}
												minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
												maxDate={new Date(new Date().getFullYear(), 11, 31)}
											/>
										</div>
										<div className="row mt-3">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													{t('cancel')}
												</button>
												<button className="btn btn-primary"
													onClick={() => searchWithFilter({ filterData: { ...filterData } })}>
													{t('apply')}
												</button>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcelFile()}
									title="EXCEL">
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						<div className="d-flex gap-2">
							<div className="vertical-center">
								<h4><b>{t('amount')}</b>:</h4>
							</div>
							<div className="vertical-center">
								<h5 className="text-end">
									<span className={`${data.total_amount > 0 ? 'text-success' : 'text-danger'}`}>{formatMoney(data.total_amount)}</span>
								</h5>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.transaction_type &&
									<span className="me-2">
										<b>{t('transaction_type')}: </b>
										{findKeyFromArrayByValue(transactionTypes, 'id', filterData.transaction_type, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover cursor mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '10%' }} >{t("payment")}</th>
									<th style={{ 'width': '35%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('debit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('credit')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('total')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className={'cursor ' + (item.showSidebar ? 'table-tr-active' : '')}
										onClick={() => {
											if (item.cheque_id) toggleRightbar(true, item, index)
										}}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.pos_name}</td>
										<td className="td-ellipsis">{item.account_chef_name}</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="text-center">
											{/* Списанный долг: плюс мимо кассы и без счёта. Погашение из кабинета
												идёт на сейф / банк — у него есть счёт, и это не списание */}
											{(!item.cashbox_id && item.transaction_type === 'plus' && !item.account_chef_name) ?
												<CustomTooltip text={t('write_off')}>
													<span className="text-danger">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</span>
												</CustomTooltip>
												:
												<span>{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</span>
											}
										</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'plus' && <span className="text-success">{formatMoney(item.amount)}</span>}
										</td>
										<td className="text-end text-nowrap">
											{item.transaction_type === 'minus' && <span>{formatMoney(item.amount)}</span>}
										</td>
										<td className={`text-end ${item.balance > 0 ? 'text-success' : 'text-danger'}`}>
											{formatMoney(item.balance)}
										</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td colSpan="7" className="text-end fw-bold">{t('total')}</td>
									<td className={`text-end text-nowrap fw-bold ${data.total_amount >= 0 ? 'text-success' : 'text-danger'}`}>
										{formatMoney(data.total_amount)}
									</td>
								</tr>
							</tfoot>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>
		</>
	)
}

export default Index
